import { render, staticRenderFns } from "./VaultLogs.vue?vue&type=template&id=28243e37&scoped=true&"
import script from "./VaultLogs.vue?vue&type=script&lang=js&"
export * from "./VaultLogs.vue?vue&type=script&lang=js&"
import style0 from "./VaultLogs.vue?vue&type=style&index=0&id=28243e37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28243e37",
  null
  
)

export default component.exports